<template>
  <div class="relative">
    <label class="text-sm font-bold block dark:text-white">
      <span v-if="$slots['label']">
        <slot name="label" />
      </span>
      <span v-else>
        {{ label }}
      </span>

      <span
        v-if="isRequired"
        class="text-red"
      >
        *
      </span>
    </label>

    <select
      v-bind="$attrs"
      class="block w-full mt-1 rounded-lg p-4 placeholder-gray-250 focus:ring-0"
      :class="[errorClasses, classes]"
      :value="modelValue"
      :name="name"
      :required="isRequired"
      @input="(e) => $emit('update:modelValue', e.target.value)"
    >
      <option
        v-for="option in options"
        :key="option.key"
        :value="option.key"
      >
        {{ option.value }}
      </option>
    </select>

    <span
      v-if="form.errors && form.errors[name]"
      class="block text-red-500 text-sm mt-1"
    >
      * {{ form.errors[name] }}
    </span>
  </div>
</template>

<script>
import Field from './Field';

export default {
  mixins: [Field],

  props: {
    options: {
      type: Array,
      required: true,
    },
  },

  emits: ['update:modelValue'],
};
</script>
